import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Drawer } from '@mui/material';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LeftBar from '../components/LeftBar';
import { logout } from '../utils/logout';
import ContactSupport from '../components/ContactSupport';

const INACTIVITY_LIMIT = 60 * 60 * 1000; // 60 minutes

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const timerRef = useRef();

  useEffect(() => {
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {
        await logout();
        navigate('/signin');
      }, INACTIVITY_LIMIT);
    };

    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [navigate]);

  return (
    <div className='flex min-h-screen min-w-full   '>
      <div className='max-sm:hidden'>
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
      <Drawer
        open={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        className='sm:hidden'
      >
        <LeftBar
          setIsSidebarOpen={setIsSidebarOpen}
          isSidebarOpen={isSidebarOpen}
        />
      </Drawer>
      <div
        className='flex flex-col max-h-screen transition-all duration-300 overflow-y-auto'
        style={{
          flex: 1,
          width: `calc(100% - 240px)`,
          transition: 'margin-left 0.3s, width 0.3s',
        }}
      >
        <Header setIsSidebarOpen={setIsSidebarOpen} className='sticky top-0 ' />
        <Box variant='main' className='flex-1   '>
          {children}
        </Box>
        <Footer />
      </div>
      <ContactSupport></ContactSupport>
    </div>
  );
};

export default AdminLayout;
